import Vue from 'vue'
import VueRouter from 'vue-router'
import Menu from '../views/Menu.vue'
import moment from 'moment'

Vue.use(VueRouter)

Vue.filter('toCurrency', function (value) {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});

Vue.filter('toTwelveHours', function (timestr) {
  return moment('2000-01-01T'+timestr).format('h:mma');
});

Vue.filter('toTextDate', function (date) {
  return moment(date).format('ddd Do MMM');
});

const routes = [
  {
    path: '/',
    name: 'Menu',
    component: Menu
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
